import { ref } from 'vue'
import { defineStore } from 'pinia'

type ActiveChat = 'voyada' | 'support' | null

export const useChatStore = defineStore('chat', () => {
  const activeChat = ref<ActiveChat>(null)
  // Prevents MutationObserver callbacks from firing while we are mid-transition
  let _programmatic = false
  let _zohoFailureHandlerRegistered = false

  function registerZohoFailureHandler(loader: TtgZohoSalesIqLoader) {
    if (_zohoFailureHandlerRegistered) return
    _zohoFailureHandlerRegistered = true
    loader.onFailed(() => {
      if (activeChat.value === 'support') activeChat.value = null
      _programmatic = false
    })
  }

  function showZohoSupport() {
    const loader = window.__ttgZohoSalesIq
    if (!loader || loader.failed) return false
    registerZohoFailureHandler(loader)
    loader.show()
    return true
  }

  function hideZohoSupport() {
    window.__ttgZohoSalesIq?.hide()
  }

  function toggleVoyada() {
    if (activeChat.value === 'voyada') {
      _programmatic = true
      window.VoyadaWidget?.close()
      activeChat.value = null
      requestAnimationFrame(() => {
        _programmatic = false
      })
      return
    }
    _programmatic = true
    if (activeChat.value === 'support') {
      hideZohoSupport()
      activeChat.value = 'voyada'
      requestAnimationFrame(() => {
        window.VoyadaWidget?.open()
        requestAnimationFrame(() => {
          _programmatic = false
        })
      })
    } else {
      window.VoyadaWidget?.open()
      activeChat.value = 'voyada'
      requestAnimationFrame(() => {
        _programmatic = false
      })
    }
  }

  function toggleSupport() {
    if (activeChat.value === 'support') {
      _programmatic = true
      hideZohoSupport()
      activeChat.value = null
      requestAnimationFrame(() => {
        _programmatic = false
      })
      return
    }
    _programmatic = true
    if (activeChat.value === 'voyada') {
      window.VoyadaWidget?.close()
    }
    if (!showZohoSupport()) {
      activeChat.value = null
      requestAnimationFrame(() => {
        _programmatic = false
      })
      return
    }
    activeChat.value = 'support'
    requestAnimationFrame(() => {
      _programmatic = false
    })
  }

  function onZohoClosed() {
    if (_programmatic) return
    if (activeChat.value === 'support') activeChat.value = null
  }

  function onVoyadaClosed() {
    if (_programmatic) return
    if (activeChat.value === 'voyada') activeChat.value = null
  }

  function onVoyadaOpened() {
    if (_programmatic) return
    activeChat.value = 'voyada'
  }

  return {
    activeChat,
    toggleVoyada,
    toggleSupport,
    onZohoClosed,
    onVoyadaClosed,
    onVoyadaOpened
  }
})
